import Vue from 'vue'
import CopyComponent from "./CopyComponent";

// Tags
import a from './Tags/A'
import div from './Tags/Div'
import span from './Tags/Span'
import strong from './Tags/Strong';
import H1 from './Tags/H1'
import H2 from './Tags/H2'
import H3 from './Tags/H3'
import H4 from './Tags/H4'
import H5 from './Tags/H5'
import H6 from './Tags/H6'
import P from './Tags/P'
import Footer from './Tags/Footer'
import Header from './Tags/Header'
import Small from './Tags/Small'
import Section from './Tags/Section'
import Img from './Tags/Img'
import Figure from './Tags/Figure'

// update site message
import UpdateSiteMessage1 from './UpdateSiteMessage/UpdateSiteMessage1'

// Navs
import Nav1 from './Nav/Nav1/Nav1'
import Nav2 from './Nav/Nav2/Nav2'
import Nav3 from './Nav/Nav3/Nav3'
import Nav4 from './Nav/Nav4/Nav4'
import Nav5 from './Nav/Nav5/Nav5'
import Nav6 from './Nav/Nav6/Nav6'
import Nav7 from './Nav/Nav7'
import Nav400 from './Nav/Nav400/Nav400'
import Nav200 from './Nav/Nav200/Nav200'
import Nav501 from './Nav/Nav501/Nav501'
import Nav101 from './Nav/Nav101/Nav101'
import Nav100 from './Nav/Nav100/Nav100'
import Nav600 from './Nav/Nav600/Nav600'
import Nav601 from './Nav/Nav601/Nav601'
import Nav800 from './Nav/Nav800'
import Nav301 from './Nav/Nav301/Nav301.vue'


// Cards
import C1 from './Cards/C1'
import C2 from './Cards/C2'
import C3 from './Cards/C3'
import C4 from './Cards/C4'
import C5 from './Cards/C5/C5'
import C6 from './Cards/C6/C6'
import C10 from './Cards/C10'
import C11 from './Cards/C11'
import C12 from './Cards/C12'
import C13 from './Cards/C13'
import C14 from './Cards/C14'
import C15 from './Cards/C15'
import C16 from './Cards/C16'
import C17 from './Cards/C17'
import C31 from './Cards/C31'
import C21 from './Cards/C21'
import C22 from './Cards/C22'
import C32 from './Cards/C32'
import C33 from './Cards/C33'
import C200 from './Cards/C200'
import C100 from './Cards/C100'
import C101 from './Cards/C101'
import C512 from './Cards/C512'
import C102 from './Cards/C102'
import C103 from './Cards/C103'
import C104 from './Cards/C104'
import C513 from './Cards/C513'
import C514 from './Cards/C514'
import C515 from './Cards/C515'
import C516 from './Cards/C516'
import C301 from './Cards/C301'
import C800 from './Cards/C800'
import C801 from './Cards/C801'
import C802 from './Cards/C802'
import C300 from './Cards/C300'
import C302 from './Cards/C302'
import C303 from './Cards/C303'
import C304 from './Cards/C304'
import C305 from './Cards/C305'

// Grids
import G1 from './Grids/G1'
import G2 from './Grids/G2'
import G3 from './Grids/G3'
import G4 from './Grids/G4'

// Footers
import F1 from './Footers/F1/F1'
import F2 from './Footers/F2/F2'
import F3 from './Footers/F3/F3'
import F6 from './Footers/F6/F6'
import F4 from './Footers/F4/F4'
import F7 from './Footers/F7/F7'
import F400 from './Footers/F400/F400'
import F511 from './Footers/F511/F511'
import F100 from './Footers/F100/F100'
import F600 from './Footers/F600/F600'

// Sections
import S1 from './Sections/S1'
import S2 from './Sections/S2'
import S3 from './Sections/S3'
import S4 from './Sections/S4'
import S5 from './Sections/S5'
import S6 from './Sections/S6'
import S7 from './Sections/S7'
import S8 from './Sections/S8'
import S9 from './Sections/S9'
import S10 from './Sections/S10'
import S11 from './Sections/S11'
import S12 from './Sections/S12'
import S13 from './Sections/S13'
import S14 from './Sections/S14'
import S20 from './Sections/S20'
import S21 from './Sections/S21'
import S22 from './Sections/S22'
import S23 from './Sections/S23'
import S24 from './Sections/S24'
import S503 from './Sections/S503'
import S400 from './Sections/S400'
import S201 from './Sections/S201'
import S101 from './Sections/S101'
import S504 from './Sections/S504'
import S510 from './Sections/S510'
import S513 from './Sections/S513'
import S514 from './Sections/S514'
import S102 from './Sections/S102'
import S104 from './Sections/S104'
import S515 from './Sections/S515'
import S517 from './Sections/S517'
import S900 from './Sections/S900'
import S300 from './Sections/S300'

// Physical products
import Products_1 from "./Products/Physical/Products_1/Products1";
import Products_2 from "./Products/Physical/Products_2/Products2";
import Products_3 from "./Products/Physical/Products_3/Products3";
import Products_4 from "./Products/Physical/Products_4/Products4";
import Products_400 from "./Products/Physical/Products_400/Products400";
import Products300 from "./Products/Physical/Products_300/Products300";
import Products100 from "./Products/Physical/Products_100/Products100";
import Products301 from "./Products/Products301/Products301";


// digital products
import DigitalProducts1 from "./Products/Digital/Products_1/DigitalProducts1";
import DigitalProducts2 from "./Products/Digital/Products_2/DigitalProducts2";

// favorite products
import FavoriteProducts1 from "./Products/FavoriteProducts/FavoriteProducts1";
import FavoriteProducts100 from "./Products/FavoriteProducts/FavoriteProducts100";

//product card controls
import ShoppingCartController1 from "./ShoppingCart/ShoppingCards/ShoppingCartController1";
import ShoppingCartController2 from "./ShoppingCart/ShoppingCards/ShoppingCartController2";



//shopping cart quantity Manager
import ShoppingCartQuantityManager1 from "./ShoppingCart/ShoppingCards/ShoppingCartQuantityManager1";

// Singles post
import SinglePost1 from './Singles/Post/SinglePost1'
import SinglePost2 from './Singles/Post/SinglePost2'
import SinglePost501 from './Singles/Post/SinglePost501'
import SinglePostRelated300 from './Singles/Post/SinglePostRelated300'

// single page
import SinglePage1 from './Singles/Page/SinglePage1'


// Single Course
import SingleCourse1 from './Singles/Course/SingleCourse1'

// Single Product
import SingleProduct1 from './Singles/Product/SingleProduct1'
import SingleProduct600 from './Singles/Product/SingleProduct600'

// Courses
import Courses1 from './Courses/Courses1/Courses1'
import Courses2 from './Courses/Courses2/Courses2'

// single lesson
import SingleLesson1 from './Singles/lesson/SingleLesson1'


// Posts Archive
import Posts1 from './Posts/Posts1'
import Posts2 from './Posts/Posts2'
import Posts400 from './Posts/Posts400'
import Posts501 from './Posts/Posts501'


// Pages Archive
import Pages1 from './Pages/Pages1'
import Pages2 from './Pages/Pages2'
import Pages500 from './Pages/Pages500'

// Sliders
import slider1 from './Slider/Slider1'
import slider2 from './Slider/Slider2'
import slider3 from './Slider/Slider3'
import slider301 from './Slider/Slider301'
import slider100 from './Slider/Slider100'
import slider101 from './Slider/Slider101'
import Slider302 from './Slider/Slider302'
import Slider900 from './Slider/Slider900'
import Slider303 from './Slider/Slider303/Slider303'
import Slider304 from './Slider/Slider304'

// Related Products
import RelatedProducts300 from './Singles/Product/RelatedProducts300'
import RelatedProducts301 from './Singles/Product/RelatedProducts301'

// Buttons
import Bt1 from "./Buttons/Bt1.vue";
import Bt2 from "./Buttons/Bt2.vue";
import Bt3 from "./Buttons/Bt3.vue";
import Bt4 from "./Buttons/Bt4.vue";
import Bt5 from "./Buttons/Bt5"
import Bt6 from "./Buttons/Bt6"
import Bt7 from "./Buttons/Bt7"
import Bt8 from "./Buttons/Bt8"
import Bt9 from "./Buttons/Bt9"
import Bt10 from "./Buttons/Bt10"
import Bt400 from "./Buttons/Bt400"
import Bt401 from "./Buttons/Bt401"
import Bt402 from "./Buttons/Bt402"
import Bt403 from "./Buttons/Bt403"
import Bt404 from "./Buttons/Bt404"
import Bt405 from "./Buttons/Bt405"
import Bt406 from "./Buttons/Bt406"
import Bt407 from "./Buttons/Bt407"
import Bt408 from "./Buttons/Bt408"
import Bt100 from "./Buttons/Bt100"
import Bt101 from "./Buttons/Bt101"
import Bt600 from "./Buttons/Bt600"
import Bt503 from "./Buttons/Bt503"
import Bt300 from "./Buttons/Bt300"

// Buttons
import Pil1 from "./Buttons/Pil1.vue";

// Icons
import Icon from "./Icons/Icon";
import Ic1 from "./Icons/Ic1";
import Ic2 from "./Icons/Ic2";
import Ic3 from "./Icons/Ic3";

// deliveries
import Deliver1 from "./ShoppingCart/Delivery/Deliver1";

// payments
import Payment1 from "./ShoppingCart/Payment/Payment1";


// VerifyTransaction
import VerifyTransaction1 from "./ShoppingCart/VerifyTransaction/VerifyTransaction1";

// NotFound
import NotFound1 from "./NotFound/NotFound1";


// ShoppingCard
import Sc1 from "./ShoppingCart/ShoppingCards/ShoppingCard1/Sc1";
import Sc2 from "./ShoppingCart/ShoppingCards/Sc2";
import Sc3 from "./ShoppingCart/ShoppingCart3";

// Login
import Login1 from "./Authentication/Login/Login1";


// Register
import Register1 from "./Authentication/Register/Register1/Register1";


// Cellphone Reset Password
import ResetCellphonePassword1 from "./Authentication/ResetCellPhonePassword/ResetCellphonePassword1";

// Forget password
import ForgetPassword1 from "./Authentication/ForgetPassword/ForgetPassword1";

// Email Reset password
import ResetEmailPassword1 from "./Authentication/ResetEmailPassword/ResetEmailPassword1";

// Verify Email
import VerifiedEmail1 from "./Authentication/VerifyEmail/VerifiedEmail1";

// Verify cell-phone
import VerifiedCellphone1 from "./Authentication/VerifyCellPhone/VerifiedCellphone1";

// unAuthShoppingCart
import UnAuthenticatedShoppingCart1 from './UnAuthenticatedShoppingCart/Cart1/UnAuthenticatedShoppingCart1'

// UnPaidOrder
import DigitalShoppingCart1 from './ShoppingCart/ShoppingCards/DigitalShoppingCart/DigitalShoppingCart1'


// OrderPaidFactor1
import Factor1 from './ShoppingCart/Factors/Factor1/Factor1'

// Pagination
import Pagination400 from "./pagination/Pagination-400";


// create modal comments
import CreateCommentModal1 from "./Comments/CreateComment/Modal/CreateCommentModal1";


// side comments
import SideComments1 from "./Comments/ShowComment/SideComment/SideComment1/SideComments1";

// Offer Products
import OfferProducts100 from "./Products/OfferProducts/OfferProducts100";
import OfferProducts101 from "./Products/OfferProducts/OfferProducts101";
import OfferProducts300 from "./Products/OfferProducts/OfferProducts300";


// Product Price
import Price100 from "./Products/Price/Price100";


// side comments
import NormalComment1 from "./Comments/ShowComment/Normal/Comment1";

// Brands archive
import Brands300 from "./Brands/Brands300";

// single brand
import SingleBrand300 from './Singles/Brand/SingleBrand300'

// Categories archive
import Categories300 from "./Categories/Categories300";
import PostCategories300 from "./Categories/PostCategories300";
import Categories301 from "./Categories/Categories301";
import Categories302 from "./Categories/Categories302";
import Categories303 from "./Categories/Categories303";
import Categories304 from "./Categories/Categories304";
import CategoriesPanel300 from "./Categories/CategoriesPanel300";
import CategoriesPanel301 from "./Categories/CategoriesPanel301";
import Categories305 from "./Categories/Categories305";

// single category
import SingleCategory300 from "./Singles/Category/SingleCategory300";

// wrappers
import CategoriesWrapper from "./Categories/CategoriesWrapper";
import ContentsWrapper from './Posts/ContentsWrapper'
import SingleContentsWrapper from "./Singles/SingleContentsWrapper";
import ProductsWrapper from "./Products/ProductsWrapper";
import SingleProductWrapper from "./Singles/Product/SingleProductWrapper";
import SingleCourseWrapper from "./Singles/Course/SingleCourseWrapper";
import SingleProductPriceWrapper from "./Singles/Product/SingleProductPriceWrapper";
import SingleProductPrice1 from "./Singles/Product/SingleProductPrice1";
import SingleLessonWrapper from "./Singles/lesson/SingleLessonWrapper";
import ShoppingCartWrapper from "./ShoppingCart/ShoppingCartWrapper";

// Titles
import Title100 from "./Titles/Title100";

// search input
import SearchInput1 from "../plugin/Search/input/SearchInput1";
import SearchInput2 from "../plugin/Search/input/SearchInput2";
import SearchInput3 from "../plugin/Search/input/SearchInput3";

// search page
import SearchPage1 from "../plugin/Search/page/Search1/Search1";

// loading
import Loading1 from "../plugin/Loading/Loading1";

// editItem
/*
*
*
* */
import EditItem1 from "../plugin/EditItem/EditItem1";

Vue.component('m-edit-item-1', EditItem1)


// create modal comments
Vue.component('m-comment-create-modal-1', CreateCommentModal1)

// create modal comments
Vue.component('m-comments-1', NormalComment1)


// copy component
Vue.component('m-copy-component', CopyComponent)

// side comments
Vue.component('m-comments-side-1', SideComments1)

// Tags
Vue.component('m-div', div)
Vue.component('m-a', a)
Vue.component('m-span', span)
Vue.component('m-h1', H1)
Vue.component('m-h2', H2)
Vue.component('m-h3', H3)
Vue.component('m-h4', H4)
Vue.component('m-h5', H5)
Vue.component('m-h6', H6)
Vue.component('m-strong', strong)
Vue.component('m-p', P)
Vue.component('m-footer', Footer)
Vue.component('m-header', Header)
Vue.component('m-small', Small)
Vue.component('m-section', Section)
Vue.component('m-img', Img)
Vue.component('m-figure', Figure)

// Navs
Vue.component('m-nav-1', Nav1)
Vue.component('m-nav-2', Nav2)
Vue.component('m-nav-3', Nav3)
Vue.component('m-nav-4', Nav4)
Vue.component('m-nav-5', Nav5)
Vue.component('m-nav-6', Nav6)
Vue.component('m-nav-7', Nav7)
Vue.component('m-nav-400', Nav400)
Vue.component('m-nav-200', Nav200)
Vue.component('m-nav-501', Nav501)
Vue.component('m-nav-101', Nav101)
Vue.component('m-nav-100', Nav100)
Vue.component('m-nav-600', Nav600)
Vue.component('m-nav-601', Nav601)
Vue.component('m-nav-800', Nav800)
Vue.component('m-nav-301', Nav301)


// products components
Vue.component('m-products-1', Products_1)
Vue.component('m-products-2', Products_2)
Vue.component('m-products-3', Products_3)
Vue.component('m-products-4', Products_4)
Vue.component('m-products-400', Products_400)
Vue.component('m-products-100', Products100)
Vue.component('m-products-300', Products300)
Vue.component('m-products-301', Products301)

Vue.component('m-digital-products-1', DigitalProducts1)
Vue.component('m-digital-products-2', DigitalProducts2)

// Cards
Vue.component('m-c1', C1)
Vue.component('m-c2', C2)
Vue.component('m-c3', C3)
Vue.component('m-c4', C4)
Vue.component('m-c5', C5)
Vue.component('m-c6', C6)
Vue.component('m-c10', C10)
Vue.component('m-c11', C11)
Vue.component('m-c12', C12)
Vue.component('m-c13', C13)
Vue.component('m-c14', C14)
Vue.component('m-c15', C15)
Vue.component('m-c16', C16)
Vue.component('m-c17', C17)
Vue.component('m-c31', C31)
Vue.component('m-c21', C21)
Vue.component('m-c22', C22)
Vue.component('m-c32', C32)
Vue.component('m-c33', C33)
Vue.component('m-c200', C200)
Vue.component('m-c100', C100)
Vue.component('m-c101', C101)
Vue.component('m-c512', C512)
Vue.component('m-c102', C102)
Vue.component('m-c103', C103)
Vue.component('m-c104', C104)
Vue.component('m-c301', C301)
Vue.component('m-c513', C513)
Vue.component('m-c514', C514)
Vue.component('m-c515', C515)
Vue.component('m-c516', C516)
Vue.component('m-c800', C800)
Vue.component('m-c801', C801)
Vue.component('m-c802', C802)
Vue.component('m-c300', C300)
Vue.component('m-c302', C302)
Vue.component('m-c303', C303)
Vue.component('m-c304', C304)
Vue.component('m-c305', C305)


// Grades
Vue.component('m-g1', G1)
Vue.component('m-g2', G2)
Vue.component('m-g3', G3)
Vue.component('m-g4', G4)


// Sections
Vue.component('m-s1', S1)
Vue.component('m-s2', S2)
Vue.component('m-s3', S3)
Vue.component('m-s4', S4)
Vue.component('m-s5', S5)
Vue.component('m-s6', S6)
Vue.component('m-s7', S7)
Vue.component('m-s8', S8)
Vue.component('m-s9', S9)
Vue.component('m-s10', S10)
Vue.component('m-s11', S11)
Vue.component('m-s12', S12)
Vue.component('m-s13', S13)
Vue.component('m-s14', S14)
Vue.component('m-s20', S20)
Vue.component('m-s21', S21)
Vue.component('m-s22', S22)
Vue.component('m-s23', S23)
Vue.component('m-s24', S24)
Vue.component('m-s24', S24)
Vue.component('m-s503', S503)
Vue.component('m-s400', S400)
Vue.component('m-s201', S201)
Vue.component('m-s101', S101)
Vue.component('m-s504', S504)
Vue.component('m-s510', S510)
Vue.component('m-s513', S513)
Vue.component('m-s514', S514)
Vue.component('m-s515', S515)
Vue.component('m-s517', S517)
Vue.component('m-s102', S102)
Vue.component('m-s104', S104)
Vue.component('m-s900', S900)
Vue.component('m-s300', S300)
// Footers
Vue.component('m-f1', F1)
Vue.component('m-f2', F2)
Vue.component('m-f3', F3)
Vue.component('m-f4', F4)
Vue.component('m-f6', F6)
Vue.component('m-f7', F7)
Vue.component('m-f400', F400)
Vue.component('m-f100', F100)
Vue.component('m-f511', F511)
Vue.component('m-f600', F600)


// Buttons
Vue.component('m-bt1', Bt1)
Vue.component('m-bt2', Bt2)
Vue.component('m-bt3', Bt3)
Vue.component('m-bt4', Bt4)
Vue.component('m-bt5', Bt5)
Vue.component('m-bt6', Bt6)
Vue.component('m-bt7', Bt7)
Vue.component('m-bt8', Bt8)
Vue.component('m-bt9', Bt9)
Vue.component('m-bt10', Bt10)
Vue.component('m-bt400', Bt400)
Vue.component('m-bt401', Bt401)
Vue.component('m-bt402', Bt402)
Vue.component('m-bt403', Bt403)
Vue.component('m-bt404', Bt404)
Vue.component('m-bt405', Bt405)
Vue.component('m-bt406', Bt406)
Vue.component('m-bt407', Bt407)
Vue.component('m-bt408', Bt408)
Vue.component('m-bt100', Bt100)
Vue.component('m-bt101', Bt101)
Vue.component('m-bt600', Bt600)
Vue.component('m-bt503', Bt503)
Vue.component('m-bt300', Bt300)


//single post
Vue.component('m-single-post-1', SinglePost1)
Vue.component('m-single-post-2', SinglePost2)
Vue.component('m-single-post-501', SinglePost501)
Vue.component('m-single-post-related-300', SinglePostRelated300)

//single page
Vue.component('m-single-page-1', SinglePage1)


//single Courses
Vue.component('m-single-course-1', SingleCourse1)

//single Products
Vue.component('m-single-product-1', SingleProduct1)
Vue.component('m-single-product-600', SingleProduct600)

//Posts Archive
Vue.component('m-posts-1', Posts1)
Vue.component('m-posts-2', Posts2)
Vue.component('m-posts-400', Posts400)
Vue.component('m-posts-501', Posts501)

//Posts Archive
Vue.component('m-pages-1', Pages1)
Vue.component('m-pages-2', Pages2)
Vue.component('m-pages-500', Pages500)

// pills
Vue.component('m-pil1', Pil1)

// Icons
Vue.component('m-icon', Icon)
Vue.component('m-ic1', Ic1)
Vue.component('m-ic2', Ic2)
Vue.component('m-ic3', Ic3)

// Sliders
Vue.component('m-slider-1', slider1)
Vue.component('m-slider-2', slider2)
Vue.component('m-slider-3', slider3)
Vue.component('m-slider-301', slider301)
Vue.component('m-slider-100', slider100)
Vue.component('m-slider-101', slider101)
Vue.component('m-slider-302', Slider302)
Vue.component('m-slider-900', Slider900)
Vue.component('m-slider-303', Slider303)
Vue.component('m-slider-304', Slider304)

// related products
Vue.component('m-related-products-301', RelatedProducts301)
Vue.component('m-related-products-300', RelatedProducts300)


// deliveries
Vue.component('m-deliver-1', Deliver1)

// payments
Vue.component('m-payment-1', Payment1)


// VerifyTransaction
Vue.component('m-verify-transaction-1', VerifyTransaction1)

// ShoppingCard
Vue.component('m-shopping-cart-1', Sc1)
Vue.component('m-shopping-cart-2', Sc2)
Vue.component('m-shopping-cart-3', Sc3)

// Shopping Cart Controller
Vue.component('m-shopping-cart-controller-1', ShoppingCartController1)
Vue.component('m-shopping-cart-controller-2', ShoppingCartController2)

// Shopping Cart quantity manager
Vue.component('m-shopping-cart-quantity-manager-1', ShoppingCartQuantityManager1)

// digital ShoppingCard
Vue.component('m-digital-shopping-cart-1', DigitalShoppingCart1)

// Login
Vue.component('m-login-1', Login1)

// Register
Vue.component('m-register-1', Register1)

// forget password
Vue.component('m-forget-password-1', ForgetPassword1)

// reset cellphone  password
Vue.component('m-reset-cell-phone-password-1', ResetCellphonePassword1)

// reset email  password
Vue.component('m-reset-email-password-1', ResetEmailPassword1)

// verify email
Vue.component('m-verify-email-1', VerifiedEmail1)

// verify cell phone
Vue.component('m-verify-cell-phone-1', VerifiedCellphone1)


// unAuthShoppingCart
Vue.component('m-un-auth-shopping-cart-1', UnAuthenticatedShoppingCart1)


// courses
Vue.component('m-courses-1', Courses1)
Vue.component('m-courses-2', Courses2)

// single lesson
Vue.component('m-single-lesson-1', SingleLesson1)

// Factors
Vue.component('m-factor-1', Factor1)

// Not Found 404
Vue.component('m-not-found-1', NotFound1)

// update site message
Vue.component('m-update-site-message-1', UpdateSiteMessage1)

// Pagination
Vue.component('m-pagination-400', Pagination400)

// Favorite Products
Vue.component('m-favorite-products-300', FavoriteProducts1)
Vue.component('m-favorite-products-100', FavoriteProducts100)

// Offer Products
Vue.component('m-offer-products-100', OfferProducts100)
Vue.component('m-offer-products-101', OfferProducts101)
Vue.component('m-offer-products-300', OfferProducts300)


// brand archive
Vue.component('m-brands-300', Brands300)

// single brand
Vue.component('m-single-brand-300', SingleBrand300)

// categories archive
Vue.component('m-categories-300', Categories300)
Vue.component('m-post-categories-300', PostCategories300)
Vue.component('m-categories-301', Categories301)
Vue.component('m-categories-302', Categories302)
Vue.component('m-categories-303', Categories303)
Vue.component('m-categories-304', Categories304)
Vue.component('m-categories-panel-300', CategoriesPanel300)
Vue.component('m-categories-panel-301', CategoriesPanel301)
Vue.component('m-categories-305', Categories305)

// single brand
Vue.component('m-single-category-300', SingleCategory300)

// Product Price
Vue.component('m-product-price-100', Price100)


// Single Product Price
Vue.component('m-single-product-price-1', SingleProductPrice1)


// Titles
Vue.component('m-title-100', Title100)


// wrappers
Vue.component('m-products-wrapper', ProductsWrapper)
Vue.component('m-contents-wrapper', ContentsWrapper)
Vue.component('m-categories-wrapper', CategoriesWrapper)
Vue.component('m-single-contents-wrapper', SingleContentsWrapper)
Vue.component('m-single-product-wrapper', SingleProductWrapper)
Vue.component('m-single-course-wrapper', SingleCourseWrapper)
Vue.component('m-single-product-price-wrapper', SingleProductPriceWrapper)
Vue.component('m-single-lesson-wrapper', SingleLessonWrapper)
Vue.component('m-shopping-cart-wrapper', ShoppingCartWrapper)

// search input
Vue.component('m-search-input-1', SearchInput1)
Vue.component('m-search-input-2', SearchInput2)
Vue.component('m-search-input-3', SearchInput3)

// search page
Vue.component('m-search-page-1', SearchPage1)

// Loading
Vue.component('m-loading-1', Loading1)

